import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isTokenExpired, clearSession } from "../../utils/session";

function ProtectedRoute({ children, allowedRoles }) {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const authProvider = localStorage.getItem("authProvider");
  const profileCompleted = localStorage.getItem("profileCompleted");
  const isCompletionRoute = location.pathname === "/complete-profile";

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isTokenExpired(token)) {
    clearSession();
    return <Navigate to="/login?session=expired" replace />;
  }

  if (authProvider === "google" && profileCompleted === "false" && !isCompletionRoute) {
    return <Navigate to="/complete-profile" replace />;
  }

  if (authProvider === "google" && profileCompleted === "true" && isCompletionRoute) {
    if (role === "owner") return <Navigate to="/owner-dashboard" replace />;
    if (role === "renter") return <Navigate to="/renter-dashboard" replace />;
    return <Navigate to="/" replace />;
  }

  if(allowedRoles && !allowedRoles.includes(role)){
    if(role==="owner"){
        return <Navigate to="/list-property" replace/>;
    }
    return <Navigate to="/" replace/>;
  }

  return children;
}

export default ProtectedRoute;
